import { formatNumber, formatMoney, formatPercentage } from '@belong/common';
import { Image, Text } from '@belong/ui';

type DemographicsSectionProps = {
  population: number;
  medianHouseholdIncome: number;
  percentMarried: number;
};

export function DemographicsSection({
  population,
  medianHouseholdIncome,
  percentMarried,
}: DemographicsSectionProps) {
  return (
    <div className="gap-y-xl grid grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/population.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {formatNumber(population)}
        </Text>
        <Text>Population</Text>
      </div>
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/median_household_income.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {formatMoney(medianHouseholdIncome)}
          <Text as="span" variant="p1" fontWeight="semibold">
            / yr
          </Text>
        </Text>
        <Text>Median Household Income </Text>
      </div>
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/percent_married.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {formatPercentage(percentMarried / 100)}
        </Text>
        <Text>Percent Married</Text>
      </div>
    </div>
  );
}
